import { QRCode } from "react-qrcode-logo"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

interface PaymentLinkQrModalProps {
  url: string;
  children: React.ReactNode;
}

export default function PaymentLinkQrModal({
  url,
  children,
}: PaymentLinkQrModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Payment Link</DialogTitle>
          <DialogDescription>
            Scan this QR code to open the payment link on your phone:
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <div className="border rounded-md overflow-hidden">
            <QRCode value={url} size={180} />
          </div>
        </div>
        <DialogClose />
      </DialogContent>
    </Dialog>
  )
}
